import ReCAPTCHA from "react-google-recaptcha";
import { Path, PathValue, useFormContext } from "react-hook-form";

const useRecaptcha = <T extends { recaptcha?: string | null }>(
    recaptcha: React.RefObject<ReCAPTCHA>,
) => {
    const { setError, clearErrors, setValue } = useFormContext<T>();

    const verifyCaptcha = (): boolean => {
        const recaptchaValue = recaptcha.current?.getValue();
        if (!recaptchaValue) {
            setError("recaptcha" as Path<T>, {
                type: "custom",
                message: "Please verify the reCAPTCHA!",
            });
            return false;
        } else {
            clearErrors("recaptcha" as Path<T>);
            return true;
        }
    };

    const onChangeRecaptcha = async (token: string | null): Promise<void> => {
        const recaptchaValue = recaptcha.current?.getValue();
        if (recaptchaValue) {
            setValue(
                "recaptcha" as Path<T>,
                recaptchaValue as PathValue<T, Path<T>>,
            );
        }
        verifyCaptcha();
        // TODO: Verify response by sending token to back-end API
    };

    return { verifyCaptcha, onChangeRecaptcha };
};

export default useRecaptcha;
